import { Component, inject, Input, OnInit } from '@angular/core';
import { SidePanelStateService } from 'app/services/side-panel/side-panel-state.service';
import { SidebarService } from 'app/services/sidebar/sidebar.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent implements OnInit {
  @Input() title!: string;
  @Input() protocolNumber: string | null = null;
  private sidebarService: SidebarService = inject(SidebarService);
  private sidePanelStateService: SidePanelStateService = inject(SidePanelStateService);

  sidebarCollapsed!: boolean;
  sidePanelExpanded!: boolean;

  ngOnInit() {
    this.sidebarService.sidebarCollapsed$.subscribe((collapsed) => {
      this.sidebarCollapsed = collapsed;
    });

    this.sidePanelStateService.sidePanelExpanded$.subscribe((expanded) => {
      this.sidePanelExpanded = expanded;
    });
  }
}
